import React, { useEffect, useState } from "react"
import { Form, Row } from "reactstrap"
import Select from "react-select"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import axios from "axios"
import { fetchNodeData } from "utils/common-fetchData"
import { useNavigate, useParams } from "react-router-dom"
import configure from "configure"
import moment from "moment"
import { BiddingStatus, locationOptions, TenderStatus } from "utils/common-options"
import Swal from "sweetalert2"
import Loader from "pages/Separate/Loader"
import { useSelector } from "react-redux"

const BiddingProfile = () => {
  const { id } = useParams()
  const [biddingName, setBiddingName] = useState("")
  const [applyDate, setApplyDate] = useState("")
  const [submissionDate, setSubmissionDate] = useState("")
  const [currency, setCurrency] = useState("")
  const [contractValue, setContractValue] = useState("")
  const [status, setStatus] = useState(null)
  const [location, setLocation] = useState(null)
  const [biddingDocument, setBiddingDocument] = useState(null)
  const [projectDescription, setProjectDescription] = useState("")
  const [currency_option, setCurrencyOption] = useState([])
  const [isLoading, setLoading] = useState(false)
  const getLocations = useSelector(state => state?.location?.locations)
  const generalData = useSelector(state => state?.GeneralData?.generalData)
  const [assignee, setAssignee] = useState([])
  const [communicator, setCommunicator] = useState([])
  const [duration, setDuration] = useState('')
  const [prerequisites, setPrerequisites] = useState('')
  const [source, setSource] = useState('')
  const [company, setCompany] = useState('')
  const [companyEmail, setCompanyEmail] = useState('')
  const [companyNumber, setCompanyNumber] = useState('')
  const [companyAddress, setCompanyAddress] = useState('')
  const [contactName, setContactName] = useState('')
  const [contactPhone, setContactPhone] = useState('')
  const [contactEmail, setContactEmail] = useState('')
  const [connects, setConnects] = useState('')
  const navigate = useNavigate()
  const getData = async () => {
    try {
      const response = await fetchNodeData(
        setLoading,
        `bidding/${id}/${localStorage.getItem("auth_id")}`,
        localStorage.getItem("auth_token")
      )

      if (response?.data) {
        const data = response.data
        setSource(data?.source)
        setBiddingName(data.name || "")
        setApplyDate(
          data.apply_date ? moment(data.apply_date).format("YYYY-MM-DD") : ""
        )
        setSubmissionDate(
          data.bidding_submittion_date
            ? moment(data.bidding_submittion_date).format("YYYY-MM-DD")
            : ""
        )
        setCurrency(data.currency ? String(data.currency) : "")
        setContractValue(data.budget || "")
        setStatus(BiddingStatus?.find((obj) => obj?.value == data?.status))
        setStatus(TenderStatus?.find((obj) => obj?.value == data?.status))
        setLocation(
          data.location
            ? locationOptions.find(opt => opt.value === String(data.location))
            : null
        )
        setProjectDescription(data.description || "")
        setPrerequisites(data?.project_prerequisite)
        setDuration(data?.project_duration)
        setCommunicator(generalData?.staff?.find((obj) => obj?.value == data?.bidding_communicator))
        setAssignee(generalData?.staff?.find((obj) => obj?.value == data?.bidding_assignee))
        setCompany(data?.company_name)
        setCompanyEmail(data?.company_email)
        setCompanyNumber(data?.company_phone)
        setCompanyAddress(data?.company_address)
        setContactName(data?.contact_name)
        setContactEmail(data?.contact_email)
        setContactPhone(data?.contact_phone)
        setConnects(data?.connects)
      }
    } catch (error) {
      console.error("Error fetching bidding data", error)
    }
  }
  const colourStyles = {
    menu: base => ({ ...base, zIndex: 1200 }),
  }

  const handleSubmit = async e => {
    e.preventDefault()
    const formData = {
      id: id,
      location: location?.value,
      biddingName: biddingName,
      applyDate: applyDate,
      submissionDate: submissionDate,
      aboutbidding: projectDescription,
      budget: parseFloat(contractValue),
      currency: parseInt(currency),
      status: status?.value,
      biddingCommunicator: communicator?.value,
      projectPrerequisite: prerequisites,
      projectDuration: duration,
      biddingAssignee: assignee?.value,
      company_name: company,
      company_email: companyEmail,
      company_phone: companyNumber,
      company_address: companyAddress,
      contact_name: contactName,
      contact_email: contactEmail,
      contact_phone: contactPhone,
      file: biddingDocument,
      connects: connects
    }
    try {
      setLoading(true)
      const response = await axios.put(`${configure.nodeApi}/bidding`, formData)
      if (response.data.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Bidding updated successfully",
        })
        getData()
        setLoading(false)
      } else {
        Swal.fire({
          icon: "error",
          title: "error",
          text: response.data.message,
        })
        setLoading(false)
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "error",
        text: error.message,
      })
      setLoading(false)
    }
  }

  const fetchCurrency = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${configure.nodeApi}/currency`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      setCurrencyOption(
        res.data.currency.map(item => ({
          label: `${item.symbol}-${item.currency}`,
          value: String(item.id),
        }))
      )
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getData()
    fetchCurrency()
  }, [])

  return (
    <div>
      {isLoading && <Loader />}
      <Form onSubmit={handleSubmit}>
        <div className="bg-white px-4 py-4 shadow mb-3 bd-span-input">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="text-dark">Edit Bidding</h5>
            <div className="text-end">
              <button
                type="submit"
                className=" btn ms-md-2 btn-save  btn-label"
              >
                <i className="fas fa-save me-1 label-icon"></i> save
              </button>
              <a
                onClick={e => {
                  navigate(-1)
                }}
                className=" btn ms-md-2 btn-red  btn-label "
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                CANCEL
              </a>
            </div>
          </div>
          <Row>
            <div className="col-md-3 mb-3">
              <label>Location</label>
              <Select
                className="basic-multi-select"
                classNamePrefix="select"
                options={getLocations}
                value={location}
                onChange={e => setLocation(e)}
                styles={colourStyles}
                placeholder="Select Location"
              />
            </div>
            <div className="col-md-9 mb-3">
              <label>Bidding Name</label>
              <input
                type="text"
                className="form-control"
                value={biddingName}
                onChange={e => setBiddingName(e.target.value)}
                required
              />
            </div>

            <div className="col-md-3 mb-3">
              <label>Apply Date</label>
              <input
                type="date"
                className="form-control"
                value={applyDate}
                onChange={e => setApplyDate(e.target.value)}
                required
              />
            </div>

            <div className="col-md-3 mb-3">
              <label>Bidding Submission Date</label>
              <input
                type="date"
                className="form-control"
                value={submissionDate}
                onChange={e => setSubmissionDate(e.target.value)}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label htmlFor="">Budget</label>
              <div className="d-flex">
                <div className="" style={{ width: "20%" }}>
                  <select
                    className="form-control border-right-none"
                    value={currency}
                    onChange={e => setCurrency(e.target.value)}
                    style={{ backgroundColor: "#eff2f7" }}
                    required
                  >
                    <option value="">Select</option>
                    {currency_option.map((obj, i) => (
                      <option key={i} value={obj.value}>
                        {obj.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex-grow-1">
                  <input
                    type="text"
                    placeholder="Enter Value"
                    className="form-control border-left-none"
                    value={contractValue || ""}
                    onChange={e => setContractValue(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <label htmlFor="">Status</label>
              <Select
                placeholder="Status"
                className="basic-multi-select"
                classNamePrefix="select"
                styles={colourStyles}
                options={BiddingStatus}
                value={status}
                onChange={e => setStatus(e)}
              />
            </div>

            <div className="col-md-3">
              <label htmlFor="">Assignee</label>
              <Select
                placeholder="Select Assignee"
                className="basic-multi-select"
                classNamePrefix="select"
                styles={colourStyles}
                options={generalData?.staff}
                value={assignee}
                onChange={e => setAssignee(e)}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="">Bidding Communicator</label>
              <Select
                placeholder="Select Communicator"
                className="basic-multi-select"
                classNamePrefix="select"
                styles={colourStyles}
                options={generalData?.staff}
                value={communicator}
                onChange={e => setCommunicator(e)}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label>Bidding Document</label>
              <input
                type="file"
                className="form-control"
                onChange={e => setBiddingDocument(e.target.files[0])}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label htmlFor="">Connects</label>
              <input
                type="text"
                placeholder="Enter Connects"
                className="form-control"
                value={connects}
                onChange={e => setConnects(e.target.value)}
                required
              />
            </div>

          </Row>
        </div>
        <div className="bg-white px-4 py-4 shadow mb-3 bd-span-input">
          <Row>
            <h5 className="mb-3">Project Information</h5>
            <div className="col-md-4 mb-3">
              <label htmlFor="">Bidding Link</label>
              <input
                type="text"
                placeholder="Bidding Link"
                className="form-control"
                value={duration}
                onChange={e => setDuration(e.target.value)}
              />
            </div>
            <div className="col-12">
              <label htmlFor=""> Bidding Prerequisites </label>
              <CKEditor
                editor={ClassicEditor}
                data={prerequisites || ''}
                onChange={(event, editor) => {
                  setPrerequisites(editor.getData())
                }}
              />
            </div>
            <div className="col-12 mt-3 mb-3">
              <label>Project Description</label>
              <CKEditor
                editor={ClassicEditor}
                data={projectDescription || ''}
                onChange={(event, editor) => {
                  setProjectDescription(editor.getData())
                }}
              />
            </div>
          </Row>
        </div>
        <div className="bg-white px-4 py-4 shadow mb-3 bd-span-input">
          <Row >
            <h5 className="mb-3">Contact Information</h5>
            <div className="col-md-3 mb-3">
              <label htmlFor="">Company Name</label>
              <input
                type="text"
                placeholder="Enter Company Name"
                className="form-control"
                value={company}
                onChange={e => setCompany(e.target.value)}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label htmlFor="">Company Email Address</label>
              <input
                type="text"
                placeholder="Enter Company Email Address"
                className="form-control"
                value={companyEmail}
                onChange={e => setCompanyEmail(e.target.value)}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label htmlFor="">Company Phone No.</label>
              <input
                type="number"
                placeholder="Enter Company Phone No."
                className="form-control"
                value={companyNumber}
                onChange={e => setCompanyNumber(e.target.value)}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label htmlFor="">Company Address</label>
              <input
                type="text"
                placeholder="Enter Company Address"
                className="form-control"
                value={companyAddress}
                onChange={e => setCompanyAddress(e.target.value)}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label htmlFor="">Contact Name</label>
              <input
                type="text"
                placeholder="Enter Contact Name"
                className="form-control"
                value={contactName}
                onChange={e => setContactName(e.target.value)}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label htmlFor="">Contact Email</label>
              <input
                type="email"
                placeholder="Enter Contact Email"
                className="form-control"
                value={contactEmail}
                onChange={e => setContactEmail(e.target.value)}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label htmlFor="">Contact Phone No.</label>
              <input
                type="number"
                placeholder="Enter Contact Phone No."
                className="form-control"
                value={contactPhone}
                onChange={e => setContactPhone(e.target.value)}
              />
            </div>
          </Row>
        </div>
      </Form>
    </div >
  )
}

export default BiddingProfile
